import React from "react";
import { NavLink } from "react-router-dom";
import { Home, UserPlus, Phone, Users, Menu } from "lucide-react";
import { cn } from "../../lib/utils";

const mobileNavItems = [
  { icon: Home, label: "Home", path: "/dashboard" },
  { icon: UserPlus, label: "Leads", path: "/leads" },
  { icon: Phone, label: "Calls", path: "/calls" },
  { icon: Users, label: "Customers", path: "/customers" },
  { icon: Menu, label: "Menu", path: "/menu" }
];

export const MobileBottomNav = ({ onMenuClick }) => {
  return (
    <nav className="mobile-bottom-nav md:hidden" data-testid="mobile-bottom-nav">
      {mobileNavItems.map((item) => {
        if (item.label === "Menu") {
          return (
            <button
              key={item.label}
              onClick={onMenuClick}
              className="mobile-bottom-nav-item"
              data-testid="mobile-nav-menu"
            >
              <item.icon className="w-5 h-5" />
              <span className="text-[10px] font-medium">{item.label}</span>
            </button>
          );
        }
        return (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              cn("mobile-bottom-nav-item", isActive && "active")
            }
            data-testid={`mobile-nav-${item.label.toLowerCase()}`}
          >
            <item.icon className="w-5 h-5" />
            <span className="text-[10px] font-medium">{item.label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
};

export default MobileBottomNav;
